import { render, staticRenderFns } from "./LogoutBtn.vue?vue&type=template&id=4dfe33ce&"
import script from "./LogoutBtn.vue?vue&type=script&lang=js&"
export * from "./LogoutBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports